import { Box, styled, useTheme } from '@mui/material';
import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import {ResponsiveThemeValue} from '../../commons/commonFunctions';
export interface HDProgressCircleTypes {
  size?: number,
  thickness?: number,
  color?: string,
  progressColor?: string,
  completedColor?: string,
  completedIconColor?: string,
  status: 'noStarted' | 'started' | 'completed' | string;
  circleBackground?: string,
}

const HDProgressCircle = (props: HDProgressCircleTypes) => {
  const theme = useTheme();
  const size = (props.size) ? props.size : 20;
  const thickness = (props.thickness) ? props.thickness : 1;
  const color = (props.color) ? props.color : ResponsiveThemeValue(theme, '#74ADBA', '#75A2B0');
  const progressColor = (props.progressColor) ? props.progressColor : '#18768C';
  const completedColor = (props.completedColor) ? props.completedColor : ResponsiveThemeValue(theme, '#18768C', '#2CDADA');
  const completedIconColor = (props.completedIconColor) ? props.completedIconColor : ResponsiveThemeValue(theme, '#18768C', '#66FCFC');

  const BeginBox = styled(Box)(() => ({
    width: size + 'px',
    height: size + 'px',
    border: thickness + 'px solid ' + color,
    borderRadius: '100%',
  }));

  const StartedBox = styled(Box)(() => ({
    width: size,
    height: size,
    border: thickness + 'px solid ' + progressColor,
    borderRadius: '100%',
    position: 'absolute',
    left: 0,
    background: 'rgba(18, 171, 171, 0.4)',
    clipPath: 'inset(0px 0px 0px 50%)',
    top: 0
  }));

  const CompletedBox = styled(Box)(() => ({
    border: thickness + 'px solid ' + completedColor,
    width: size + 'px',
    borderRadius: '100%',
    height: size + 'px',
    display: 'flex',
    justifyContent: 'center'
  }));

  const CompletedIcon = styled(CheckIcon)(() => ({
    color: completedIconColor,
    fontSize: size + 'px',
    padding: '15%',
    height: 'auto !important',
  }));

  return (
    <>
      <Box sx={{ position: 'relative' }}>
        {props.status === 'notStarted' && <BeginBox></BeginBox>}
        {props.status === 'started' && <><BeginBox></BeginBox><StartedBox></StartedBox></>}
        {props.status === 'completed' && <CompletedBox><CompletedIcon /></CompletedBox>}
      </Box>
    </>
  );
}

export default HDProgressCircle;
